import { createFileRoute, Link, useParams } from '@tanstack/react-router'
import { EmployeeTaskDetailView } from '@/components/employee-center/EmployeeTaskDetailView'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/employee-center/requests_/$taskId',
)({
  component: RouteComponent,
  staticData: { employeeCenterLayout: 'fullBleed' },
})

function RouteComponent() {
  const { workspaceId } = useParams({ strict: false }) as { workspaceId: string }
  return (
    <EmployeeTaskDetailView
      showBreadcrumbInHeader
      backLink={
        <Link
          to='/workspaces/$workspaceId/employee-center/requests'
          params={{ workspaceId }}
          className='shrink-0 text-text-subtle hover:text-text-secondary'
        >
          My Requests
        </Link>
      }
    />
  )
}
